<template>
    <v-data-table
        v-model="selected"
        :headers="headers"
        :items="list"
        item-key="id"
        :show-select="selectable"
        :disable-pagination="true"
        :hide-default-footer="true"
        :fixed-header="true"
        height="500"
        @input="updateSelection"
    >
        <template
            v-slot:item.b_name="{ item }">
            <v-icon v-if="!item.b_name" x-small color="red" title="Billing name is missing">
                fa-exclamation-triangle
            </v-icon>
            {{ item.b_name }}<br/>
            {{ item.b_name2 }}<br v-if="item.b_name2"/>
            <small>{{ createClientName(item) }}</small>
        </template>
        <template v-slot:item.order_date="{ item }">
            {{ item.order_date | formatDate }}
        </template>
        <template v-slot:item.commision="{ item }">
            <v-icon v-if="!item.provisioned" x-small color="red" title="Commision is not assigned">
                fa-exclamation-triangle
            </v-icon>
            <div v-if="item.provisioned">{{ commision(item.provisioned) }}</div>
        </template>
        <template v-slot:item.amount="{ item }">
            {{ amount(item.amount) }}
        </template>
    </v-data-table>
</template>

<script>

    export default {
        name: "list",

        props: {
            list: {},
            curr: null,
            selectable: false
        },

        data() {
            return ({
                selected: [],
                headers: [
                    {text: 'Invoice number', align: 'left', value: 'id', sortable: true},
                    {text: 'Billing name', align: 'left', value: 'b_name'},
                    {text: 'Ordered at', value: 'order_date', sortable: true},
                    {text: 'Commision', value: 'commision', sortable: true},
                    {text: 'Notice', value: 'notice', sortable: true},
                    {text: 'Amount', align: 'right', value: 'amount'}
                ],

            })
        },

        computed: {
            iSelected() {
                return this.selected
            }
        },

        methods: {
            createClientName(item) {
                return item.client.name + ' ' + item.client.surname
            },

            amount(amount) {
                return this.$options.filters.toCurrency(parseFloat(amount), this.curr)
            },

            updateSelection() {
                this.$store.commit('invoices/updateSelection', this.selected)
            },

            commision(to) {
                return to.profile.name+' '+to.profile.surname
            }
        }
    }
</script>

<style scoped>

</style>
